// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { CashRegisterTypeFragmentFragment } from './cash-register-type.fragment.generated';
export type CashRegisterFragmentFragment = { __typename?: 'CashRegisterDTO', id: number, invoiceBlocks: Array<string>, ownerCorporateDataId: number, description: string, address: string, port: string | null, localAddress: string | null, username: string | null, doubleCopy: boolean, cashRegisterType: { __typename?: 'CashRegisterTypeDTO', type: Types.CashRegisterTypeEnumDto | null, paperSize: Types.CashRegisterPaperSizeEnumDto | null, manufacturer: Types.CashRegisterManufacturerEnumDto | null } };

export const CashRegisterFragmentFragment = gql`
    fragment CashRegisterFragment on CashRegisterDTO {
  id
  invoiceBlocks
  ownerCorporateDataId
  description
  address
  port
  cashRegisterType {
    ...CashRegisterTypeFragment
  }
  localAddress
  username
  doubleCopy
}
    ${CashRegisterTypeFragmentFragment}`;
/* eslint-enable */